var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ModalConfirmation',{attrs:{"title":"Вы действительно хотите создать шаблон из данной позиции?"},on:{"confirm":_vm.createTemplate,"reject":_vm.closeModal}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }